<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de medicamento não atendido">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>


<script>
import List from '@/components/farmacia/relatorio-medicamento-nao-atendido/List'

export default{
   components:{ List } 
}

</script>